import { Reveal } from "@/components/Reveal";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { CtaContent, CtaImageUrl, WhatsAppDisplay, buildWhatsAppUrl } from "@/data/SiteContent";

export default function ContactCTA() {
  return (
    <section className="relative overflow-hidden border-y border-gold/25 bg-ink py-20 lg:py-24">
      <img
        src={CtaImageUrl}
        alt=""
        aria-hidden="true"
        loading="lazy"
        width={1600}
        height={900}
        className="absolute inset-0 h-full w-full object-cover opacity-10"
      />
      <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-8">
        <Reveal>
          <h2 className="font-serif text-3xl tracking-tight text-white sm:text-4xl">
            {CtaContent.Title}
          </h2>
          <div className="mx-auto mt-6 h-px w-16 bg-gold/70" aria-hidden="true" />
          <p className="mt-6 text-base leading-relaxed text-white/75 sm:text-lg">
            {CtaContent.Text}
          </p>
          <a
            href={buildWhatsAppUrl()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-cta-whatsapp"
            className="mt-10 inline-flex items-center gap-3 bg-gold px-8 py-4 text-sm font-medium tracking-wide text-ink transition-colors duration-300 hover:bg-gold-dark hover:text-white"
          >
            <WhatsAppIcon className="h-5 w-5" />
            {CtaContent.ButtonLabel}
          </a>
          <p className="mt-5 text-sm tracking-wide text-white/60">WhatsApp: {WhatsAppDisplay}</p>
        </Reveal>
      </div>
    </section>
  );
}
